import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { serviceSchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import { CheckSquare, Square } from "lucide-react";
import ImageUploadSingle from "../../Components/ImageUploadMultiple";

const AddServices = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [loading, setLoading] = useState(false);
    const editingId = editData?._id;
    const initalvalues = {
        sortOrder: editData?.sortOrder || 1,
        name: editData?.name || "",
        shortDescription: editData?.shortDescription || "",
        url: editData?.url || "",
        description: editData?.description || "",
        image: editData?.image || "",
        isActive: editData?.isActive ?? false,
        showInHome: editData?.showInHome ?? false,
        thumbnailImage: editData?.thumbnailImage || [],
    };

    const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
        useFormik({
            initialValues: initalvalues,
            validationSchema: serviceSchema,
            onSubmit: async (values) => {
                setLoading(true);

                try {
                    const formData = new FormData();
                    formData.append("sortOrder", values.sortOrder);
                    formData.append("name", values.name);
                    formData.append("shortDescription", values.shortDescription);
                    formData.append("url", values.url || "");
                    formData.append("description", values.description);
                    formData.append("isActive", values.isActive);
                    formData.append("showInHome", values.showInHome);

                    if (values.image instanceof File) {
                        formData.append("image", values.image);
                    }

                    if (values.thumbnailImage instanceof File) {
                        formData.append("thumbnailImage", values.thumbnailImage);
                        formData.append("existingThumbnailImage", "");
                    } else if (values.thumbnailImage) {
                        formData.append("existingThumbnailImage", values.thumbnailImage);
                    } else {
                        formData.append("existingThumbnailImage", "");
                    }
                    const response = editingId
                        ? await axiosInstance.put(
                            `/service/updateservice/${editingId}`,
                            formData
                        )
                        : await axiosInstance.post(
                            "/service/createservice",
                            formData
                        );

                    if (response.status === 200) {
                        toast.success(response.data.message);
                        navigator("/services");
                    }
                } catch (error) {
                    toast.error(error.response?.data?.message);
                } finally {
                    setLoading(false);
                }
            },
        });

    const breadcrumbdata = [
        { label: "Home", path: "/dashboard" },
        { label: "Services", path: "/services" },
        { label: editingId ? "Update" : "Add", path: "*" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mb-3">
                    <h3 className="custom-page-title">
                        {editingId ? "Update" : "Add"} Services
                    </h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>
                <div className="col-md-12 grid-margin stretch-card p-0">
                    <div className="card m-0">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="service-sortOrder"
                                                className="col-form-label "
                                            >
                                                Sort Order
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control border-dark "
                                                id="service-sortOrder"
                                                name="sortOrder"
                                                placeholder="Enter a service sort order"
                                                min={1}
                                                value={values.sortOrder}
                                                onChange={handleChange}
                                            />
                                            {touched.sortOrder && errors.sortOrder && (
                                                <small className="text-danger">
                                                    {errors.sortOrder}
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="service-link" className="col-form-label ">
                                                Service Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="service-name"
                                                name="name"
                                                placeholder="Enter service name"
                                                value={values.name}
                                                onChange={handleChange}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger">{errors.name}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="service-shortDescription"
                                                className="col-form-label "
                                            >
                                                Short Description
                                            </label>

                                            <CodeEditor
                                                value={values.shortDescription}
                                                onChange={(val) => setFieldValue("shortDescription", val)}
                                            />

                                            {touched.shortDescription && errors.shortDescription && (
                                                <small className="text-danger">
                                                    {errors.shortDescription}
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    {/* 
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="service-name" className="col-form-label ">
                                                Service Title
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border border-dark"
                                                id="service-title"
                                                name="title"
                                                placeholder="Enter service title"
                                                value={values.title}
                                                onChange={handleChange}
                                            />
                                            {touched.title && errors.title && (
                                                <small className="text-danger">{errors.title}</small>
                                            )}
                                        </div>
                                    </div> */}

                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label
                                                htmlFor="service-description"
                                                className="col-form-label "
                                            >
                                                Description
                                            </label>

                                            <CodeEditor
                                                value={values.description}
                                                onChange={(val) => setFieldValue("description", val)}
                                            />

                                            {touched.description && errors.description && (
                                                <small className="text-danger">
                                                    {errors.description}
                                                </small>
                                            )}
                                        </div>
                                    </div>


                                    <div className="col-sm-6">
                                        <ImageUploadDragAndDrop
                                            id="service-image"
                                            label={`Image (1920 X 950px)`}
                                            value={values.image}
                                            onChange={(file) => setFieldValue("image", file)}
                                            error={errors.image}
                                            touched={touched.image}
                                        />
                                    </div>

                                    <div className="col-sm-6">
                                        <ImageUploadSingle
                                            id="thumbnailImage"
                                            label="Thumbnail Image"
                                            value={values.thumbnailImage}
                                            onChange={(file) =>
                                                setFieldValue("thumbnailImage", file)
                                            }
                                            error={errors.thumbnailImage}
                                            touched={touched.thumbnailImage}
                                        />

                                    </div>

                                    <div className="col-md-6 mt-5">
                                        <div className="d-flex flex-column mb-3 " style={{ gap: "10px" }}>
                                            <div className={`menu-row p-4 ${values.showInHome ? "active" : "inActive"}`}
                                                onClick={() =>
                                                    setFieldValue("showInHome", !values.showInHome)
                                                }
                                            >
                                                {values.showInHome ? (
                                                    <CheckSquare size={20} className="icon-active" />
                                                ) : (
                                                    <Square size={20} className="icon" />
                                                )}
                                                <span className="menu-title">Show In Home</span>
                                            </div>
                                        </div>
                                        <SwitchToggle
                                            checked={values.isActive}
                                            onChange={(val) => setFieldValue("isActive", val)}
                                        />
                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <Button type="submit" color="primary" disabled={loading}>
                                        {loading ? (
                                            <span className="d-inline-flex align-items-center gap-2">
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>

                                    <Link to="/services">
                                        <Button color="danger mx-2">Cancel </Button>
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddServices;
